export const SETTINGS_TABS = [
  'Profile',
  'Account',
  'Notifications & Alerts',
  'Integrations',
  'Help & Support',
] as const;

export type TabKey = (typeof SETTINGS_TABS)[number];

export type ProfileRow = {
  label: string;
  value: string;
  actionLabel?: string;
};

export type NotificationKey =
  | 'emailMatchAlert'
  | 'emailUpcomingSessionReminder'
  | 'emailSessionCancellation'
  | 'emailReschedulingRequest'
  | 'emailPlatformAnnouncement'
  | 'emailNewMessage'
  | 'inAppUpcomingSessionReminder'
  | 'inAppSessionChanges'
  | 'inAppNewStudentAssigned'
  | 'inAppNewMessage'
  | 'inAppActionRequired'
  | 'inAppAttendanceUpdate'
  | 'inAppPlatformUpdate';

export type NotificationSetting = {
  key: NotificationKey;
  label: string;
  description: string;
};

export type SelectOption = {
  value: string;
  label: string;
};

export type IntegrationKey =
  | 'googleCalendar'
  | 'outlookCalendar'
  | 'zoomCalendar'
  | 'appleCalendar';

export type IntegrationOption = {
  key: IntegrationKey;
  label: string;
  description: string;
  icon: string;
  iconBg: string;
  iconText: string;
};
